import * as uuid from 'uuid';
export class Guid {
    value;
    static next() {
        return new Guid(uuid.v4());
    }
    static default() {
        return new Guid('00000000-0000-4000-8000-000000000000');
    }
    static isValid(obj) {
        if (!obj) {
            return false;
        }
        const stringObj = obj.toString();
        return /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(stringObj);
    }
    static fromString(str) {
        if (!Guid.isValid(str)) {
            return null;
        }
        return new Guid(str);
    }
    constructor(value) {
        this.value = value;
    }
    isDefault() {
        return this.value === Guid.default().value;
    }
    is(another) {
        if (!another) {
            return false;
        }
        return this.value === another.value;
    }
    toString() {
        return this.value;
    }
    toAlphaNumericString() {
        return this.value.replace(/-/g, '');
    }
}
//# sourceMappingURL=guid.js.map